import { Button, Calendar, FlyoutButton, Spinner } from '@acpaas-ui/react-components';
import 'moment/locale/nl';
import { useEffect, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { usePrevious } from '../../hooks/usePrevious';

const CalendarButton = ({ value, isLoading, disabled, onChange }) => {
  const buttonId = useRef(uuid()).current;
  const prevIsLoading = usePrevious(isLoading);

  useEffect(() => {
    if (!isLoading && prevIsLoading) {
      document.getElementById(`calendar-button-${buttonId}`)?.click();
    }
  }, [buttonId, isLoading, prevIsLoading]);

  return (
    <div className="spo-a-calendar-button">
      {disabled ? (
        <Button
          size="tiny"
          iconRight="ai-calendar"
          aria-label="Volgende deadline"
          outline
          className="open-button--disabled u-margin-right-sm"
        >
          {value || 'Geen'}
        </Button>
      ) : (
        <FlyoutButton
          id={`calendar-button-${buttonId}`}
          size="tiny"
          iconRight="ai-calendar"
          aria-label="Volgende deadline"
          outline
          className="open-button u-margin-right-sm"
          label={value || 'Geen'}
        >
          <div>
            <Calendar locale={'nl'} format={'DD/MM/YYYY'} onChange={onChange} minDate={new Date()} />
            {isLoading && (
              <div className="loader">
                <p className="u-text-bold">Volgende deadline bijwerken...</p>
                <Spinner />
              </div>
            )}
          </div>
        </FlyoutButton>
      )}
    </div>
  );
};

export default CalendarButton;
